import Vue from 'vue';
import UserInfo from '@/modules/UserInfo.js';
import url from './url.js';
import filter from './filter.js';

Vue.prototype.$warn = function (msg) {
    this.$message({
        type: 'warning',
        message: msg
    });
}
 
  /**
       * 
       * 产生随机字符串
       * @param int $length
       * @return 产生的随机字符串
       */
  Vue.prototype.$getRandom = function (length = 32, prefix = '') {
    const chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'g', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let result = prefix;
    while (result.length < length) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }
  
  //复制内容
  Vue.prototype.$copy = function (str) {
  
    var oInput = document.createElement('input');
    oInput.value = str;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    document.body.removeChild(oInput);
  }

Vue.prototype.$error = function (msg) {
    this.$message({
        type: 'error',
        message: msg
    });
}

Vue.prototype.$info = function (msg) {
    this.$message({
        type: 'info',
        message: msg
    });
}

Vue.prototype.$success = function (msg) {
    this.$message({
        type: 'success',
        message: msg
    });
}
Vue.prototype.$isPower = function (num) {
    return num.indexOf(this.$UserInfo.RoleDefaultId) >= 0;
}

Vue.prototype.$isAuth = function (authName) {
    if (typeof this.$UserInfo['SystemSetup'] == 'undefined') {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.replace('/Login');
        return false;
    }
    const SystemSetup = this.$UserInfo.SystemSetup.split(',');
    return SystemSetup.indexOf(authName) >= 0;
}


window.exportAuth = [];

Vue.prototype.$setExport = function (arr) {
    window.exportAuth = arr;
}

Vue.prototype.$eAuth = function (name) {
    return window.exportAuth.indexOf(name) >= 0;
}


Vue.prototype.$export = function (tname, data = {}) {
    // const loading = this.$loading({
    //     lock: true,
    //     text: '下载中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    // });
    data.tablename = tname;
    this.$http.post('/Export/ExportTableRecord/', data).then((res) => {
        window.open(res.data);
        //     $el.attr('src', url.devUrl + res.data);
        //     $el.attr('onunload', () => {
        //         loading.close();
        //         // setTimeout(() => {
        //         // $('.iframe-e').remove();
        //         // }, 500);
        //     })
        //     $el.addClass('iframe-e');
        //     $el.appendTo($('body'));
        // }).catch((err) => {

    });

}

